import { render, staticRenderFns } from "./SteelspaceLogoColor.svg.vue?vue&type=template&id=a2842d00"
import script from "./SteelspaceLogoColor.svg.vue?vue&type=script&lang=ts"
export * from "./SteelspaceLogoColor.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2842d00')) {
      api.createRecord('a2842d00', component.options)
    } else {
      api.reload('a2842d00', component.options)
    }
    module.hot.accept("./SteelspaceLogoColor.svg.vue?vue&type=template&id=a2842d00", function () {
      api.rerender('a2842d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/SteelspaceLogoColor.svg.vue"
export default component.exports